import { useGlobalContext } from '@/lib/context';
import styles from './ShopifyPopup.module.css';
import { useEffect, useState } from 'react';
import { getCookie } from '@/lib/helpers/Cookie';
import { LoginType } from '@/lib/constants';
import { pushRoute } from '@/lib/helpers/common';
export function ShopifyPopup() {
    const { props: { isMobileView } } = useGlobalContext();
    const [showPopup, setShowPopup] = useState(false);
    const LoginData = getCookie(LoginType.LOGIN);
    useEffect(() => {
        setTimeout(() => {
            if (!sessionStorage.getItem('isSignupPopup')) {
                (!getCookie('isSignupPopup') && !LoginData) && setShowPopup(true);
            }
        }, 20000)
    }, []);
    if (showPopup === false) return <></>;
    return (
        <>
            {
                !isMobileView ?
                    <div className={styles.stepExitOverlay}>
                        <div className={styles.strpEximbox}>
                            <img className="img-responsive" src="/assets/images/stepIntowebimg.png" alt="stepIntowebimg" />
                            <div className={styles.crossBtbox} onClick={() => { setShowPopup(false), sessionStorage.setItem('isSignupPopup', 'false') }}>
                                <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="1" width="24" height="24" rx="2" fill="white" stroke="#CBCBCB" strokeWidth="0.5" />
                                    <path d="M17.5 8L7.5 18" stroke="#222222" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M7.5 8L17.5 18" stroke="#222222" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={styles.viewMorebt}>
                                <button onClick={() => pushRoute(process.env.SHOP_URL)}>Visit Now</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.stepExitmob}>
                        <div className={styles.SteopMobminbox}>
                            <img className="img-responsive" src="/assets/images/stepIntomob.png" alt="stepIntomob" />
                            <div className={styles.crossBtbmob} onClick={() => { setShowPopup(false), sessionStorage.setItem('isSignupPopup', 'false') }}>
                                <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="1" width="24" height="24" rx="2" fill="white" stroke="#CBCBCB" strokeWidth="0.5" />
                                    <path d="M17.5 8L7.5 18" stroke="#222222" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M7.5 8L17.5 18" stroke="#222222" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className={styles.viewMbtmob}>
                                <button onClick={() => pushRoute(process.env.SHOP_URL)}>Visit Now</button>
                            </div>
                        </div>
                    </div>
            }
        </>
    );
}   